import Joi from "joi";

const JoiOption = Joi.object({
  label: Joi.string(),
  value: Joi.string(),
  checked: Joi.any(),
});

const schema = Joi.object({
  id: Joi.number().optional(),
  codeType: Joi.string().required().messages({
    "any.required": "Harap pilih Tipe user",
  }),
  area: JoiOption.required().messages({
    "any.required": "Harap pilih Area",
  }),
  pool: JoiOption.required().messages({
    "any.required": "Harap pilih Pool",
  }),
  segment: JoiOption.required().messages({
    "any.required": "Harap pilih Segment",
  }),
  company: JoiOption.required().messages({
    "any.required": "Harap masukan Perusahaan",
  }),
  hasRelation: Joi.boolean(),
  companyRelation: JoiOption.when("hasRelation", {
    is: true,
    then: JoiOption.required().messages({
      "any.required": "Harap masukan Perusahaan Relasi",
    }),
    otherwise: JoiOption.optional(),
  }),
  isActive: Joi.boolean(),
});

export default schema;
